import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ClinicalDocumentService } from 'app/integration/document/services/clinical-document.service';
import { mergeMap } from 'rxjs/operators';
import { IframeComponent } from '@heda/core-hospital-ui/components/iframe/iframe.component';
import {
  ClinicalDocumentAttachment,
  ClinicalDocumentSearchParams,
} from 'app/integration/document/services/clinical-document';
import { base64ToBlob, openOrDownload } from '@heda/core-util';

@Component({
  selector: 'hw-document-view',
  templateUrl: './clinical-document-view.component.html',
})
export class ClinicalDocumentViewComponent implements OnInit {
  @ViewChild('preview') public previewIframe: IframeComponent;
  public loading: boolean;
  public attachments: ClinicalDocumentAttachment[];

  constructor(private activatedRoute: ActivatedRoute, private clinicalDocumentService: ClinicalDocumentService) {}

  public ngOnInit(): void {
    this.loading = true;
    this.clinicalDocumentService
      .getDocumentMeta(this.activatedRoute.snapshot.queryParams as ClinicalDocumentSearchParams)
      .pipe(
        mergeMap((meta) => {
          if (meta.hasAttachments) {
            this.clinicalDocumentService.getDocumentAttachments(meta.documentKey).subscribe((attachments) => {
              this.attachments = attachments;
            });
          }
          return this.clinicalDocumentService.getCachedDocumentUrl(meta.documentKey);
        })
      )
      .subscribe({
        next: (url) => {
          this.previewIframe.open(url);
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        },
      });
  }

  public open(a: ClinicalDocumentAttachment): void {
    const blob = base64ToBlob(a.content, a.contentType);
    openOrDownload(a.fileName, blob);
  }
}
